import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../store";
import { emergencyContactType } from "../../../common/interfaces/myProfile/personalDetails/emergencyContactType";
// Define a type for the slice state

// Define the initial state using that type

const initialState: emergencyContactType = {
  emergencyContactNumber: 0,
  emergencyPersonName: "",
  emergencyCountry: "",
  emergencyEmail: "",
  emergencyRelationship: "",
};

const emergencyContactSlice = createSlice({
  name: "emergencyContact",

  initialState,
  reducers: {
    getEmergencyDetailReducer: (
      state: emergencyContactType,
      action: PayloadAction<emergencyContactType>
    ) => {
      const payload = action.payload;
      state.emergencyContactNumber = payload.emergencyContactNumber;
      state.emergencyPersonName = payload.emergencyPersonName;
      state.emergencyCountry = payload.emergencyCountry;
      state.emergencyRelationship = payload.emergencyRelationship;
      state.emergencyEmail = payload.emergencyEmail;
    },
    resetEmergencyContact: (state: emergencyContactType) => {
      state.emergencyContactNumber = 0;
      state.emergencyPersonName = "";
      state.emergencyCountry = "";
      state.emergencyEmail = "";
      state.emergencyRelationship = "";
    },
  },
});

export const { getEmergencyDetailReducer, resetEmergencyContact } =
  emergencyContactSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default emergencyContactSlice.reducer;
